import React from 'react'

export const CARD_COUPON_UNUSED = '1'
export const CARD_COUPON_USED = '2'
export const CARD_COUPON_EXPIRED = '3'

export const CARD_COUPON = {
  [CARD_COUPON_UNUSED]: {
    bg: '//qnm.hunliji.com/o_1cn9kqddoauhc0quic1bla14uvc.png',
    empty: '您还没有可用的商家优惠券哦~',
    moneyColor: '#ff801a',
    text: (
      <div>
        去<br />
        使<br />
        用
      </div>
    )
  },
  [CARD_COUPON_USED]: {
    bg: '//qnm.hunliji.com/o_1cn9kqddo166uaibu7g1vjn1lpsd.png',
    empty: '您还没有已使用的商家优惠券哦~',
    moneyColor: '#ff801a',
    text: (
      <div style={{ color: '#666' }}>
        已<br />
        使<br />
        用
      </div>
    )
  },
  [CARD_COUPON_EXPIRED]: {
    bg: '//qnm.hunliji.com/o_1cn9kqddn1b48gtf1u5419151bq0b.png',
    empty: '您还没有已过期的商家优惠券哦~',
    moneyColor: '#aaa',
    text: (
      <div>
        已<br />
        过<br />
        期
      </div>
    )
  }
}
